
import { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { fretesService } from '../services/api'
import { useAuth } from '../contexts/AuthContext'
import './MinhasCandidaturas.css'

function MinhasCandidaturas() {
    const [candidaturas, setCandidaturas] = useState([])
    const [loading, setLoading] = useState(true)
    const [erro, setErro] = useState(null)
    const { usuario, isLogado } = useAuth()
    const navigate = useNavigate()

    useEffect(() => {
        // Redirecionar se não for motorista VERIFICADO (PAGO)
        const isVerificado = (usuario?.motorista_verificado === true || usuario?.motoristaVerificado === true) && 
                             usuario?.expiracao_motorista && 
                             new Date(usuario?.expiracao_motorista) > new Date();

        if (isLogado && !isVerificado) {
            navigate('/area-motorista')
            return
        }
        carregarCandidaturas()
    }, [isLogado, usuario, navigate])

    const carregarCandidaturas = async () => {
        setLoading(true)
        try {
            const response = await fretesService.minhasCandidaturas()
            setCandidaturas(response.candidaturas)
        } catch (error) {
            console.error('Erro ao buscar candidaturas:', error)
            setErro('Não foi possível carregar suas candidaturas.')
        } finally {
            setLoading(false)
        }
    }

    const formatPrice = (value) => {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 0
        }).format(value)
    }

    const getStatusInfo = (status) => {
        switch (status) {
            case 'pendente': return { label: 'Aguardando', class: 'status-pendente', icon: '⏳' }
            case 'aceita': return { label: 'Aprovada', class: 'status-aceita', icon: '✅' }
            case 'rejeitada': return { label: 'Rejeitada', class: 'status-rejeitada', icon: '❌' }
            case 'cancelada': return { label: 'Cancelada', class: 'status-cancelada', icon: '🚫' }
            default: return { label: status, class: '', icon: '' }
        }
    }

    if (loading) return <div className="loading">Carregando candidaturas...</div>

    return (
        <div className="candidaturas-page">
            <div className="page-header">
                <h1>Minhas Candidaturas</h1>
                <p>Acompanhe o status das suas propostas de frete</p>
            </div>

            {erro && <div className="erro-msg">{erro}</div>}

            <div className="candidaturas-list">
                {candidaturas.length > 0 ? (
                    candidaturas.map(cand => {
                        const statusInfo = getStatusInfo(cand.status)
                        return (
                            <div key={cand.id} className={`candidatura-card ${cand.status}`}>
                                <div className="card-top">
                                    <div className="status-badge">
                                        {statusInfo.icon} {statusInfo.label}
                                    </div>
                                    <span className="data-candidatura">
                                        Enviada em {new Date(cand.criado_em).toLocaleDateString()}
                                    </span>
                                </div>

                                <div className="anuncio-resumo">
                                    <h3>
                                        <Link to={`/anuncio/${cand.anuncio_id}`}>
                                            {cand.anuncio_titulo}
                                        </Link>
                                    </h3>
                                    <div className="rota-info">
                                        <span>📍 {cand.anuncio_cidade}, {cand.anuncio_estado}</span>
                                    </div>
                                </div>

                                <div className="proposta-detalhes">
                                    <div className="valor-proposto">
                                        <span>Sua Proposta:</span>
                                        <strong>{formatPrice(cand.preco_proposto)}</strong>
                                    </div>

                                    {cand.mensagem && (
                                        <div className="minha-mensagem">
                                            <span>Sua mensagem:</span>
                                            <p>"{cand.mensagem}"</p>
                                        </div>
                                    )}

                                    {cand.resposta_vendedor && (
                                        <div className="resposta-vendedor">
                                            <span>Resposta do Vendedor:</span>
                                            <p>"{cand.resposta_vendedor}"</p>
                                        </div>
                                    )}
                                </div>

                                <div className="vendedor-contato">
                                    <span>Vendedor: {cand.vendedor_nome}</span>
                                    {cand.status === 'aceita' && (
                                        <button className="btn btn-success btn-sm">
                                            📲 Entrar em Contato
                                        </button>
                                    )}
                                </div>
                            </div>
                        )
                    })
                ) : (
                    <div className="sem-candidaturas">
                        <div className="icon">📝</div>
                        <h2>Nenhuma candidatura encontranda</h2>
                        <p>Você ainda não se candidatou a nenhum frete.</p>
                        <Link to="/fretes-disponiveis" className="btn btn-primary">
                            Ver Fretes Disponíveis
                        </Link>
                    </div>
                )}
            </div>
        </div>
    )
}

export default MinhasCandidaturas
